// 비밀번호 설정

import { useMutation } from "@tanstack/react-query";
import { resetPwdApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAlertStore from "store/alert";

export const useResetPwdMutate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  return useMutation({
    mutationFn: resetPwdApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          onSetAlert({
            isOpen: true,
            inner: t("alt_reset_pass_done"),
            chkTxt: t("btn_login_cmm"),
            onSetConfirm: () => {
              navigate("/", {
                state: {},
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
